import React from 'react';
import { motion } from 'framer-motion';
export function FloatingShapes() {
  return <div className="absolute inset-0 overflow-hidden pointer-events-none z-0" data-id="element-10">
      <motion.div animate={{
      y: [0, -20, 0],
      rotate: [0, 10, 0]
    }} transition={{
      duration: 5,
      repeat: Infinity,
      ease: 'easeInOut'
    }} className="absolute top-20 left-[10%] w-24 h-24 bg-coral/20 rounded-full blur-xl" data-id="element-11" />
      <motion.div animate={{
      y: [0, 30, 0],
      rotate: [0, -15, 0]
    }} transition={{
      duration: 7,
      repeat: Infinity,
      ease: 'easeInOut',
      delay: 1
    }} className="absolute top-40 right-[15%] w-32 h-32 bg-grape/20 rounded-full blur-xl" data-id="element-12" />
      <motion.div animate={{
      y: [0, -25, 0],
      scale: [1, 1.1, 1]
    }} transition={{
      duration: 6,
      repeat: Infinity,
      ease: 'easeInOut',
      delay: 2
    }} className="absolute bottom-32 left-[20%] w-28 h-28 bg-sunshine/20 rounded-full blur-xl" data-id="element-13" />
      <motion.div animate={{
      y: [0, 20, 0],
      rotate: [0, 20, 0]
    }} transition={{
      duration: 8,
      repeat: Infinity,
      ease: 'easeInOut',
      delay: 0.5
    }} className="absolute bottom-40 right-[10%] w-20 h-20 bg-leaf/20 rounded-full blur-xl" data-id="element-14" />

      {/* Crisp shapes */}
      <motion.svg animate={{
      rotate: 360
    }} transition={{
      duration: 40,
      repeat: Infinity,
      ease: 'linear'
    }} className="absolute top-32 left-[25%] text-sunshine opacity-50 w-8 h-8" viewBox="0 0 24 24" fill="currentColor" data-id="element-15">
        <path d="M12 0L14.59 9.41L24 12L14.59 14.59L12 24L9.41 14.59L0 12L9.41 9.41L12 0Z" data-id="element-16" />
      </motion.svg>

      <motion.svg animate={{
      rotate: -360
    }} transition={{
      duration: 50,
      repeat: Infinity,
      ease: 'linear'
    }} className="absolute bottom-48 right-[25%] text-coral opacity-50 w-6 h-6" viewBox="0 0 24 24" fill="currentColor" data-id="element-17">
        <path d="M12 0L14.59 9.41L24 12L14.59 14.59L12 24L9.41 14.59L0 12L9.41 9.41L12 0Z" data-id="element-18" />
      </motion.svg>
    </div>;
}